import Detail from "../components/detail";
import Footer from "../components/footer";

import Navbar from "../components/navbar";

function DetailPage() {
  return (
    <>
      <div className="max-w-screen-xl  mx-auto pt-12 flex-col bg-fixed">
        <Navbar />
        <Detail />

        <Footer />
      </div>
    </>
  );
}
export default DetailPage;
